import React from 'react';
import '../assets/styles/components/ProgessTitle.sass';

const ProgessTitle = ({step1 = null, step2 = null, step3 = null, tour}) => (
  <div className="row">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <ul className={`ProgessTitle --${tour}`}>
            <li className={step1}>1. SELECCIONE FECHA DEL TOUR <br/> E INFO DEL CORREDOR</li>
            <li className={step2}>2. REVISE SU INFO</li>
            <li className={step3}>3. CONFIRMACIÓN</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default ProgessTitle;
